module.exports = __webpack_public_path__ + "img/buy_super_id.83072fab.png";